import { Injectable } from '@angular/core';
import { EstimateLine } from '@interfaces/EstimateLine';
import { TreeNodeTotals } from '@models/TreeNodeTotals';
import { lastValueFrom } from 'rxjs';
import { EstimateService } from './estimate.service';

@Injectable({
  providedIn: 'root'
})
export class ExpenseService {
  public constructor(public estimateService: EstimateService) {}

  public async sendChanges(totals: TreeNodeTotals, estimateLine: EstimateLine) {
    let expenseLine = estimateLine.expenseLine;

    if (!expenseLine) {
      expenseLine = this.estimateService.createExpenseLine(estimateLine.id, {});
    }

    expenseLine.unitCost = totals.expenseCostUnitCost ?? 0;
    expenseLine.quantity = totals.expenseCostQuantity ?? 0;
    expenseLine.amountCost = totals.totalExpensesCost ?? 0;

    await this.estimateService.saveChangesAsync();
  }

  public async deleteLine(estimateLineId: string | undefined) {
    if (!estimateLineId) {
      return;
    }

    const expenseLineEntities = await lastValueFrom(this.estimateService.deleteExpenseLine(estimateLineId));
    await this.estimateService.detachEntities(expenseLineEntities, false);
  }
}
